import Box from './Box';

export default Box.extend`
    display: flex;
    flex-direction: column;

    h3 {
        margin-top: 0;
    }

    input {
        margin-bottom: 0.4em;
        margin-top: 0.4em;
    }

    button {
        margin-top: 1em;
    }
`;



// WEBPACK FOOTER //
// ./src/components/Form.tsx